export default {
  // Wallet balance
  walletBalanceTitle: "Total Wallet Address Balance (USDT)",
  walletBalanceTooltip:
    "Wallet address total asset balance currently only counts (ETHEREUM, TRON, BSC, BTC, polygon and other five chain address balances)\n\nAccording to the currency values collected by this system, the total USDT balance is calculated by converting all main coins and tokens held by the address",
  clickToUpdate: "Click the button on the right to update balance",
  update: "Update",
  partialUpdateSuccess: "(Partial address balance update successful)",

  // Account total assets
  accountTotalAssets: "Account Total Assets Preview (USDT)",

  // Basic information
  basicInformation: "Basic Information",
  addCharacter: "Add Character",
  viewDetails: "View Details",
  characterSyncFailed: "Character information sync failed",

  // Basic information fields
  userId: "User ID",
  name: "Name",
  username: "Username",
  nationality: "Nationality",
  idNumber: "ID Number",
  homePlace: "Place of Origin",
  sex: "Gender",
  phone: "Phone",
  email: "Email",
  registerTime: "Registration Time",
  relatedCase: "Related Case",
  note: "Note",

  // Bitpie special fields
  bindingPhoneTime: "Phone Binding Time",
  analysisId: "Analysis ID",

  // imToken special fields
  deviceId: "Device ID",
  firstUseTime: "First Use Time",

  // Financial information
  financialInformation: "Financial Information",
  spotTrading: "Spot Trading",
  paymentInfo: "Payment Information",
  walletAddress: "Wallet Address",
  usedAddresses: "Used Addresses",
  watchedAddresses: "Watched Addresses",

  // Wallet account
  walletAccount: "Wallet Account",
  noBankFound: "No related bank found",
  wechat: "WeChat",
  alipay: "Alipay",

  // Load more
  loadMore: "records, load more",
  collapse: "Collapse",

  // Status
  has: "Yes",
  none: "No",

  // Message prompts
  copySuccess: "Copy successful!",
};
